import { useSelector } from 'react-redux';

import { getNotificationQueue } from 'src/shared/app/notification/selector/uiNotificationSelectors';

export default function useNotificationPortal(): Record<string, any> {
  return {
    queue: useSelector(getNotificationQueue),
  };
}
